<template>
  <!-- Main Wrapper -->
  <div class="main-wrapper register-surv">
    <div class="container-fluid">
      <div class="login-wrapper">
        <header class="logo-header">
          <router-link to="/" class="logo-brand">
            <img
              src="@/assets/img/login-logo.png"
              alt="Logo"
              class="img-fluid logo-dark w-25"
            />
            <h5>DATE.ME</h5>
          </router-link>
        </header>
        <div class="login-inbox">
          <div class="log-auth">
            <div class="success-pass">
              <img
                src="@/assets/img/avatar/avatar-16.png"
                alt="Success"
                class="img-fluid"
              />
            </div>
            <div class="login-auth-wrap">
              <div class="login-content-head">
                <h3>Reset Password Success</h3>
                <p class="text-center">
                  Your new password has been successfully saved.<br />
                  Now you can login with your new password
                </p>
              </div>
            </div>

            <router-link
              to="/"
              class="btn btn-primary w-100 btn-size justify-content-center"
              >Login</router-link
            >
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- /Main Wrapper -->
</template>
